<template>
  <b-col>
    <span class="menu__label">Last known network</span>
    <p v-if="modem.networkName">{{ modem.networkName }}</p>
    <p v-else>No last known network</p>
    <b-button variant="rounded" @click="changeView()">
      Modem log
      <Icon name="modem" />
    </b-button>
  </b-col>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  name: 'VisnetHubNetwork',
  computed: mapGetters({
    modem: 'substationVisnetHub/modem'
  }),
  methods: {
    changeView() {
      this.$store.dispatch('substationVisnetHub/changeChartView', {
        name: 'visnetHubModemLog'
      });
      this.$router.push({
        name: 'ModemLog'
      });
    }
  }
};
</script>
